module.exports = __webpack_public_path__ + "static/img/jiqi-0-1.2f017b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-0-1.png
// module id = KYAT
// module chunks = 0